import purify from 'dompurify';

import { useState } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { IReviewBookState } from '@store/slices';
import { NON_REFUNDABLE_TYPE } from '@constants';
import { ILoginState } from '@share/store/slices';

import { get } from 'lodash';
import { Refundability } from '@components';

import './style.scss';

interface IProps {
  displayCheckbox?: boolean;
  disable?: boolean;
  noBorders?: boolean;

  onChangeAcceptPolicy?: (e: { target: any }) => void;
}

const zero = 0;

export function CancellationPolicies(props: IProps) {

  const [showMoreBookingRemarks, setShowMoreBookingRemarks] = useState(false);

  const { account, userWallet } = useSelector((state: { loginStore: ILoginState }) => state.loginStore);
  const { bookingSummary, selectedHotelReviewClientCash, bookingComplete, booking } = useSelector((state: { reviewBookStore: IReviewBookState }) => state.reviewBookStore);
  
  const { cancellationPolicyText, refundabilityText, packageCancellationPolicies } = bookingSummary;

  const intl = useIntl();

  const getBookingRemarks = (): string => {
    if (packageCancellationPolicies && packageCancellationPolicies[zero]) {
      const { bookingCancellationPolicy } = packageCancellationPolicies[zero];

      if (bookingCancellationPolicy) {
        return bookingCancellationPolicy.bookingRemarks;
      }
    }

    return '';
  };

  const { disable, displayCheckbox, noBorders, onChangeAcceptPolicy } = props;

  const { refundability } = bookingSummary.bookingCard?.package;

  const bookingRemarks = getBookingRemarks();

  const hasClientCash = account?.hasClientCash;
  const walletIsExternal = account?.walletIsExternal;

  const isLogged = !!userWallet;

  const usedClientCash = (bookingComplete && booking) ? get(booking?.hotelSegments, '[0].clientCash', 0) : 0;
  const cancellationPolicyTextFinal = (!walletIsExternal && hasClientCash && ((isLogged && selectedHotelReviewClientCash > 0) || usedClientCash > 0)) ?
    intl.formatMessage({ id: 'cancellation.not_refundable.message.policy' }) :
    cancellationPolicyText;

  const refundabilityFinal = (!walletIsExternal && hasClientCash && isLogged && (selectedHotelReviewClientCash > 0 || usedClientCash > 0)) ? NON_REFUNDABLE_TYPE : refundability;

  return (
    <div className={`cancellation-policies pb-2 ${noBorders ? 'no-borders' : ''}`}>
      <div className="cancellation-policies__header policy">
        <label className="form-label pt-3 cancellation-policies__title secondary-font">
          <span className="h6 fw-normal bold-heading"><FormattedMessage id="cancellation.policy" />:</span>
          <Refundability />
        </label>
      </div>

      <div className="col-12 ">
        <label className="form-label">
          <span className="h6 fw-normal">{cancellationPolicyTextFinal}</span>
        </label>
      </div>

      {(!bookingComplete && NON_REFUNDABLE_TYPE === refundabilityFinal) ? (
        <div className="cancellation-policies__info">
          <p className="cancellation-policies__info-description"><FormattedMessage id="no-refundble.acknowledge" /></p>
        </div>) : null}

      {displayCheckbox ? (
        <div className="form-check pb-3">
          <input
            className="form-check-input"
            type="checkbox"
            name="policyAccepted"
            disabled={disable}
            onChange={onChangeAcceptPolicy}
          />
          <label className="form-check-label">
            <FormattedMessage id="by.checking.box.you.acknowledge.cancellation.policy" />
          </label>
        </div>

      ) : null}

      {refundabilityText && (
        <div className="cancellation-policies__info">
          <p className="cancellation-policies__info-title">
            <FormattedMessage id="refundability" />:
          </p>
          <p className="cancellation-policies__info-description">{refundabilityText}</p>
        </div>
      )}
      {bookingRemarks && (
        <div className="cancellation-policies__info">
          <div className="cancellation-policies__header">
            <h4 className="cancellation-policies__title secondary-font">
              <FormattedMessage id="booking.remarks" />:
            </h4>
          </div>
          <p
            className={`cancellation-policies__info-description ${!showMoreBookingRemarks ? 'booking-remarks' : ''}`}
            dangerouslySetInnerHTML={{ __html: purify.sanitize(bookingRemarks) }}
          >
          </p>

          <div className="booking-remarks__show-more" onClick={() => setShowMoreBookingRemarks(!showMoreBookingRemarks)}>
            <FormattedMessage id={!showMoreBookingRemarks ? 'show.more' : 'show.less'} />
          </div>
        </div>
      )}
    </div>
  );
}
